/* eslint-disable no-console */

import { ErrorInfo } from "react";
import * as datadog from "./datadog";

const initialize = () => {
  datadog.initLogger();
};

/**
 * Log a message.
 */
const info = (msg: string): void => {
  console.info(msg);
};

const warning = (msg: string): void => {
  console.warn(msg);
};

/**
 * Log uncaught error event stack trace.
 * @param event - contains all the information about the event and the error.
 */
const errorEvent = (event: ErrorEvent): void => {
  const {
    message,
    error: { stack },
  } = event;
  info(
    `logErrorEvent: message = ${message}, error stack = ${JSON.stringify(
      stack
    )}`
  );
};

/**
 * Log error info.
 * @param errorInfo {ErrorInfo} - the error object
 */
const errorInfo = (errorInfo: ErrorInfo): void => {
  info(`logError: errorInfo = ${JSON.stringify(errorInfo)}`);
};

const logger = {
  initialize,
  info,
  warning,
  errorEvent,
  errorInfo,
};

export default logger;
